import { render, staticRenderFns } from "./SelectSwiper.vue?vue&type=template&id=f2d7ccc4&"
import script from "./SelectSwiper.vue?vue&type=script&lang=js&"
export * from "./SelectSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports